/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as AppointmentActions from '@appointments/store/appointment.actions';
import { getAppointments, isAppointmentActionPending } from '@appointments/store/appointment.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { Appointment } from '@shared/models/appointment';
import { ObjectIdPipe } from '@shared/pipes/object-id.pipe';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-appointment-list',
    templateUrl: './appointment-list.component.html',
    styleUrls: ['./appointment-list.component.scss'],
    standalone: false
})
export class AppointmentListComponent implements OnInit {
  readonly tableColumns = ['address', 'customer', 'note', 'participants', 'time', 'actions'];
  appointments$: Observable<Appointment[]>;
  actionPending$: Observable<boolean>;

  constructor(
    private store: Store<State>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private objectIdPipe: ObjectIdPipe
  ) { }

  ngOnInit(): void {
    this.appointments$ = this.store.select(getAppointments);
    this.actionPending$ = this.store.select(isAppointmentActionPending);
  }

  editAppointment(appointment: Appointment): void {
    this.router.navigate(['../appointments', this.objectIdPipe.transform(appointment), 'edit'], {
      relativeTo: this.activatedRoute
    });
  }

  deleteAppointment(id: string): void {
    this.store.dispatch(new AppointmentActions.DeleteAppointment(id));
  }
}
